(function () {
  var FloatingUI

  try {
    FloatingUI = require('@floating-ui/dom')
    if (FloatingUI && !window.FloatingUIDOM) {
      window.FloatingUIDOM = FloatingUI
    }
  } catch (error) {
    FloatingUI = window.FloatingUIDOM
  }

  if (!FloatingUI) {
    console.error('Floating UI not loaded for hsn-search-v2')
    return
  }

  function isDesktop() {
    return window.innerWidth >= 992
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  function setMenuVisibility(element, shouldShow) {
    if (!element) return
    element.hidden = !shouldShow
    element.classList.toggle('hidden', !shouldShow)
  }

  function initSearch(FloatingUI, root) {
    var computePosition = FloatingUI.computePosition
    var autoUpdate = FloatingUI.autoUpdate
    var offset = FloatingUI.offset
    var flip = FloatingUI.flip
    var shift = FloatingUI.shift
    var size = FloatingUI.size
    var trigger = root.querySelector('[data-hsn-search-trigger]')
    var menu = root.querySelector('[data-hsn-search-menu]')
    var input = root.querySelector('[data-hsn-search-input]')
    var results = root.querySelector('[data-hsn-search-results]')
    var sectionItems = Array.prototype.slice.call(
      root.querySelectorAll('[data-hsn-search-section]'),
    )
    var cleanupMain = null
    var cleanupResults = null
    var submenuCleanupMap = new WeakMap()
    var searchTimeout = null
    var searchController = null
    var activeIndex = -1
    var currentResults = []
    var requestId = 0
    var baseUrl = window.baseUrl || '/'
    if (!trigger || !menu || !input || !results) return

    var menuWidthOverride = parseInt(root.getAttribute('data-menu-width') || '', 10)

    // data-menu-width is tuned for the desktop layout; on mobile the menu
    // must track the trigger width or it overflows the viewport.
    function menuWidth() {
      return (
        (isDesktop() && menuWidthOverride > 0 ? menuWidthOverride : trigger.offsetWidth) + 'px'
      )
    }
    var submenuWidthOverride = parseInt(root.getAttribute('data-submenu-width') || '', 10)
    var resultsLayout = root.getAttribute('data-results-layout') || 'stacked'
    var SUBMENU_DEFAULT_WIDTH = 352

    function closeAllSubmenus() {
      sectionItems.forEach(function (item) {
        var submenu = item.querySelector('[data-hsn-search-submenu]')
        var submenuTrigger = item.querySelector('[data-hsn-search-submenu-trigger]')
        var cleanup = submenuCleanupMap.get(item)

        if (cleanup) {
          cleanup()
          submenuCleanupMap.delete(item)
        }

        if (submenu) {
          submenu.removeAttribute('style')
          setMenuVisibility(submenu, false)
        }

        if (submenuTrigger) {
          submenuTrigger.setAttribute('aria-expanded', 'false')
        }
      })
    }

    function updateMenuPosition() {
      computePosition(trigger, menu, {
        placement: 'bottom-start',
        strategy: 'fixed',
        middleware: [
          offset(6),
          flip(),
          shift({ padding: 12 }),
          size({
            apply: function (data) {
              menu.style.maxHeight = Math.min(360, data.availableHeight) + 'px'
              menu.style.maxWidth = data.availableWidth + 'px'
            },
          }),
        ],
      }).then(function (result) {
        menu.style.position = 'fixed'
        menu.style.left = result.x + 'px'
        menu.style.top = result.y + 'px'
        menu.style.width = menuWidth()
        menu.style.zIndex = '70'
        menu.style.opacity = '1'
        menu.style.pointerEvents = 'auto'
      })
    }

    function openMenu() {
      hideResults()
      menu.style.position = 'fixed'
      menu.style.left = '0'
      menu.style.top = '0'
      menu.style.width = menuWidth()
      menu.style.opacity = '0'
      menu.style.pointerEvents = 'none'
      setMenuVisibility(menu, true)
      trigger.setAttribute('aria-expanded', 'true')
      updateMenuPosition()

      if (!cleanupMain) {
        cleanupMain = autoUpdate(trigger, menu, updateMenuPosition)
      }
    }

    function closeMenu() {
      trigger.setAttribute('aria-expanded', 'false')
      closeAllSubmenus()
      setMenuVisibility(menu, false)
      menu.removeAttribute('style')

      if (cleanupMain) {
        cleanupMain()
        cleanupMain = null
      }
    }

    function updateResultsPosition() {
      computePosition(input, results, {
        placement: 'bottom-start',
        strategy: 'fixed',
        middleware: [
          offset(6),
          flip(),
          shift({ padding: 12 }),
          size({
            apply: function (data) {
              results.style.maxHeight = Math.min(360, data.availableHeight) + 'px'
              results.style.maxWidth = data.availableWidth + 'px'
            },
          }),
        ],
      }).then(function (result) {
        results.style.position = 'fixed'
        results.style.left = result.x + 'px'
        results.style.top = result.y + 'px'
        results.style.width = input.offsetWidth + 'px'
        results.style.zIndex = '70'
        results.style.opacity = '1'
        results.style.pointerEvents = 'auto'
      })
    }

    function showResults() {
      closeMenu()
      results.style.position = 'fixed'
      results.style.left = '0'
      results.style.top = '0'
      results.style.width = input.offsetWidth + 'px'
      results.style.opacity = '0'
      results.style.pointerEvents = 'none'
      setMenuVisibility(results, true)
      input.setAttribute('aria-expanded', 'true')
      updateResultsPosition()

      if (!cleanupResults) {
        cleanupResults = autoUpdate(input, results, updateResultsPosition)
      }
    }

    function hideResults() {
      setMenuVisibility(results, false)
      input.setAttribute('aria-expanded', 'false')
      results.removeAttribute('style')
      activeIndex = -1

      if (searchController) {
        searchController.abort()
        searchController = null
      }

      requestId += 1

      if (cleanupResults) {
        cleanupResults()
        cleanupResults = null
      }
    }

    function renderResults(items) {
      if (!items.length) {
        results.innerHTML =
          '<div class="px-4 py-4 text-sm text-muted-light dark:text-muted-dark">No results found</div>'
        showResults()
        return
      }

      var rows = items
        .map(function (item, index) {
          if (resultsLayout === 'inline') {
            return (
              '<a href="' +
              escapeHtml(item.url) +
              '" class="flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-light focus-visible:bg-background-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 dark:hover:bg-background-dark dark:focus-visible:bg-background-dark" data-hsn-search-result-item data-index="' +
              index +
              '" role="option">' +
              '<span class="inline-flex h-7 min-w-12 shrink-0 items-center justify-center rounded-md bg-primary/10 px-2 text-xs font-black tabular-nums text-primary">' +
              escapeHtml(item.code) +
              '</span>' +
              '<span class="min-w-0 flex-1 truncate text-sm leading-snug text-text-light dark:text-text-dark">' +
              escapeHtml(item.title) +
              '</span>' +
              '</a>'
            )
          }
          return (
            '<a href="' +
            escapeHtml(item.url) +
            '" class="block px-4 py-3 transition-colors hover:bg-background-light focus-visible:bg-background-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 dark:hover:bg-background-dark dark:focus-visible:bg-background-dark" data-hsn-search-result-item data-index="' +
            index +
            '" role="option">' +
            '<span class="inline-flex h-6 items-center rounded-md bg-primary/10 px-2 text-xs font-black tabular-nums text-primary">' +
            escapeHtml(item.code) +
            '</span>' +
            '<p class="mt-1.5 text-sm leading-snug text-text-light line-clamp-2 dark:text-text-dark">' +
            escapeHtml(item.title) +
            '</p>' +
            '</a>'
          )
        })
        .join('')

      results.innerHTML =
        '<p class="border-b border-border-light bg-background-light px-4 py-2 text-xs font-bold uppercase tracking-widest text-muted-light dark:border-border-dark dark:bg-background-dark dark:text-muted-dark">Search results</p>' +
        '<div class="divide-y divide-border-light dark:divide-border-dark">' +
        rows +
        '</div>'

      showResults()
    }

    function updateActiveItem() {
      var items = results.querySelectorAll('[data-hsn-search-result-item]')
      Array.prototype.forEach.call(items, function (item, index) {
        item.classList.toggle('bg-background-light', index === activeIndex)
        item.classList.toggle('dark:bg-background-dark', index === activeIndex)
      })

      if (activeIndex >= 0 && items[activeIndex]) {
        items[activeIndex].scrollIntoView({ block: 'nearest' })
      }
    }

    function performSearch(query) {
      if (!query || query.length < 2) {
        hideResults()
        return
      }

      if (searchController) {
        searchController.abort()
      }

      searchController = new AbortController()
      requestId += 1
      var currentRequestId = requestId

      results.innerHTML =
        '<div class="flex items-center gap-2 px-4 py-4 text-sm text-muted-light dark:text-muted-dark">' +
        '<span aria-hidden="true" class="material-icons-outlined animate-spin text-base" data-icon="progress_activity"></span>' +
        'Searching…' +
        '</div>'
      showResults()

      fetch(baseUrl + 'hsn/api/search', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new URLSearchParams({
          q: query,
          limit: '100',
        }).toString(),
        signal: searchController.signal,
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed')
          return response.json()
        })
        .then(function (data) {
          if (currentRequestId !== requestId) return
          currentResults = Array.isArray(data.results) ? data.results : []
          renderResults(currentResults)
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return
          hideResults()
        })
        .finally(function () {
          searchController = null
        })
    }

    trigger.addEventListener('click', function (event) {
      event.stopPropagation()
      if (menu.hidden) {
        openMenu()
      } else {
        closeMenu()
      }
    })

    sectionItems.forEach(function (item) {
      var submenu = item.querySelector('[data-hsn-search-submenu]')
      var submenuTrigger = item.querySelector('[data-hsn-search-submenu-trigger]')
      var closeTimer = null

      if (!submenu || !submenuTrigger) return

      function clearCloseTimer() {
        if (closeTimer) {
          window.clearTimeout(closeTimer)
          closeTimer = null
        }
      }

      function focusFirstSubmenuLink() {
        var firstLink = submenu.querySelector('[role="menuitem"]')
        if (firstLink) firstLink.focus()
      }

      function updateSubmenuPosition() {
        computePosition(item, submenu, {
          placement: 'right-start',
          strategy: 'fixed',
          middleware: [
            offset(-6),
            flip(),
            shift({ padding: 12 }),
            size({
              apply: function (data) {
                submenu.style.maxHeight = Math.min(360, data.availableHeight) + 'px'
                submenu.style.width = Math.min(submenuWidthOverride > 0 ? submenuWidthOverride : SUBMENU_DEFAULT_WIDTH, data.availableWidth) + 'px'
              },
            }),
          ],
        }).then(function (result) {
          submenu.style.position = 'fixed'
          submenu.style.left = result.x + 'px'
          submenu.style.top = result.y + 'px'
          submenu.style.zIndex = '80'
          submenu.style.opacity = '1'
          submenu.style.pointerEvents = 'auto'
        })
      }

      function openSubmenu() {
        if (!isDesktop()) return
        clearCloseTimer()
        closeAllSubmenus()
        submenu.style.position = 'fixed'
        submenu.style.left = '0'
        submenu.style.top = '0'
        submenu.style.opacity = '0'
        submenu.style.pointerEvents = 'none'
        setMenuVisibility(submenu, true)
        submenuTrigger.setAttribute('aria-expanded', 'true')
        updateSubmenuPosition()

        if (!submenuCleanupMap.get(item)) {
          submenuCleanupMap.set(
            item,
            autoUpdate(item, submenu, updateSubmenuPosition),
          )
        }
      }

      function closeSubmenu() {
        clearCloseTimer()
        var cleanup = submenuCleanupMap.get(item)
        if (cleanup) {
          cleanup()
          submenuCleanupMap.delete(item)
        }

        submenu.removeAttribute('style')
        setMenuVisibility(submenu, false)
        submenuTrigger.setAttribute('aria-expanded', 'false')
      }

      function scheduleCloseSubmenu() {
        clearCloseTimer()
        closeTimer = window.setTimeout(function () {
          closeSubmenu()
        }, 260)
      }

      item.addEventListener('mouseenter', openSubmenu)
      item.addEventListener('mouseleave', function () {
        if (isDesktop()) scheduleCloseSubmenu()
      })
      submenu.addEventListener('mouseenter', clearCloseTimer)
      submenu.addEventListener('mouseleave', function () {
        if (isDesktop()) scheduleCloseSubmenu()
      })
      item.addEventListener('focusin', openSubmenu)
      item.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!item.contains(document.activeElement)) {
            scheduleCloseSubmenu()
          }
        }, 0)
      })
      submenu.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!item.contains(document.activeElement) && !submenu.contains(document.activeElement)) {
            scheduleCloseSubmenu()
          }
        }, 0)
      })

      submenuTrigger.addEventListener('click', function (event) {
        if (isDesktop()) {
          event.preventDefault()
          event.stopPropagation()
          openSubmenu()
          focusFirstSubmenuLink()
          return
        }

        event.preventDefault()
        event.stopPropagation()

        var isOpen = submenu.hidden
        closeAllSubmenus()
        setMenuVisibility(submenu, isOpen)
        submenuTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
      })

      submenuTrigger.addEventListener('keydown', function (event) {
        if (!isDesktop()) return
        if (
          event.key !== 'ArrowRight' &&
          event.key !== 'Enter' &&
          event.key !== ' '
        ) {
          return
        }

        event.preventDefault()
        openSubmenu()
        focusFirstSubmenuLink()
      })
    })

    input.addEventListener('input', function () {
      window.clearTimeout(searchTimeout)
      searchTimeout = window.setTimeout(function () {
        performSearch(input.value.trim())
      }, 300)
    })

    input.addEventListener('keydown', function (event) {
      var items = results.querySelectorAll('[data-hsn-search-result-item]')

      if (event.key === 'ArrowDown') {
        event.preventDefault()
        activeIndex = Math.min(activeIndex + 1, items.length - 1)
        updateActiveItem()
      } else if (event.key === 'ArrowUp') {
        event.preventDefault()
        activeIndex = Math.max(activeIndex - 1, -1)
        updateActiveItem()
      } else if (event.key === 'Enter') {
        if (activeIndex >= 0 && items[activeIndex]) {
          event.preventDefault()
          window.location.href = items[activeIndex].getAttribute('href')
        } else if (currentResults.length) {
          event.preventDefault()
          window.location.href = currentResults[0].url
        }
      } else if (event.key === 'Escape') {
        hideResults()
      }
    })

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) {
        closeMenu()
        hideResults()
      }
    })

    window.addEventListener('resize', function () {
      closeAllSubmenus()

      if (menu.hidden) return

      if (isDesktop()) {
        updateMenuPosition()
      } else {
        menu.removeAttribute('style')
      }
    })
  }

  function bootstrap() {
    if (!FloatingUI || !FloatingUI.computePosition) return

    var roots = document.querySelectorAll('[data-hsn-search-v2]')
    if (!roots.length) return

    Array.prototype.forEach.call(roots, function (root) {
      initSearch(FloatingUI, root)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap, { once: true })
  } else {
    bootstrap()
  }
})()
